// src/index.ts
var DESIGN_TOKENS_META = {
  name: "ImobDesk www",
  source: "@imobdesk/design-tokens",
  globalsCss: "@imobdesk/theme/public.css",
  fontsCss: "@imobdesk/theme/fonts.css"
};
var FONTS = [
  {
    id: "sans",
    label: "Corpo / UI",
    family: "Inter",
    cssVar: "--font-sans",
    tailwind: "font-sans",
    googleFontsUrl: "https://fonts.google.com/specimen/Inter",
    weights: ["400", "500", "600", "700"],
    usage: "Textos corridos, bot\xF5es, formul\xE1rios"
  },
  {
    id: "heading",
    label: "T\xEDtulos",
    family: "Plus Jakarta Sans",
    cssVar: "--font-heading",
    tailwind: "font-heading",
    googleFontsUrl: "https://fonts.google.com/specimen/Plus+Jakarta+Sans",
    weights: ["500", "600", "700", "800"],
    usage: "Headlines, destaques de se\xE7\xE3o"
  }
];
var COLORS = [
  { id: "indigo-50", hex: "#eef2ff", tailwind: "bg-indigo-50", usage: "Fundos claros, CTAs suaves" },
  { id: "indigo-100", hex: "#e0e7ff", tailwind: "bg-indigo-100", usage: "Bordas e highlights" },
  { id: "indigo-500", hex: "#6366f1", tailwind: "bg-indigo-500", usage: "Acento prim\xE1rio" },
  { id: "indigo-600", hex: "#4f46e5", tailwind: "bg-indigo-600", usage: "Links, sele\xE7\xE3o" },
  { id: "violet-500", hex: "#8b5cf6", tailwind: "bg-violet-500", usage: "Gradientes com indigo" },
  { id: "emerald-400", hex: "#34d399", tailwind: "text-emerald-400", usage: "Destaques em dark UI" },
  { id: "emerald-500", hex: "#10b981", tailwind: "bg-emerald-500", usage: "Sucesso, CPL/calculadoras" },
  { id: "green-500", hex: "#22c55e", tailwind: "bg-green-500", usage: "Marca positiva, CTA verde" },
  { id: "slate-50", hex: "#f8fafc", tailwind: "bg-slate-50", usage: "Fundos de p\xE1gina claros" },
  { id: "slate-100", hex: "#f1f5f9", tailwind: "bg-slate-100", usage: "Cards claros" },
  { id: "slate-600", hex: "#475569", tailwind: "text-slate-600", usage: "Texto secund\xE1rio" },
  { id: "slate-900", hex: "#0f172a", tailwind: "text-slate-900", usage: "Texto principal claro" },
  { id: "slate-950", hex: "#020617", tailwind: "bg-slate-950", usage: "Hero escuro, superf\xEDcies premium" }
];
var TEXT_GRADIENTS = [
  {
    id: "text-gradient-indigo",
    utilityClass: "text-gradient-indigo",
    css: "linear-gradient(135deg, #818cf8, #6366f1, #4f46e5)",
    notes: "Destaques em p\xE1ginas com tema \xEDndigo"
  },
  {
    id: "text-gradient-green",
    utilityClass: "text-gradient-green",
    css: "linear-gradient(135deg, #4ade80, #22c55e, #16a34a)",
    notes: "Marca positiva, \u2018ImobDesk\u2019 em headlines"
  },
  {
    id: "text-gradient-emerald",
    utilityClass: "text-gradient-emerald",
    css: "linear-gradient(135deg, #34d399, #10b981, #059669)",
    notes: "Calculadora CPL, scripts WhatsApp"
  },
  {
    id: "text-gradient-gemini",
    utilityClass: "text-gradient-gemini",
    css: "linear-gradient(135deg, #818cf8, #a78bfa, #c084fc, #f472b6, #fb923c, #34d399) / background-size 200% + anima\xE7\xE3o gemini-shift",
    notes: "Highlight multicolor (ex.: site-imobili\xE1rio); animado"
  }
];
var SURFACE_GRADIENTS = [
  {
    id: "hero-dark-indigo",
    label: "Hero escuro (\xEDndigo)",
    tailwind: "bg-gradient-to-br from-slate-950 via-indigo-950 to-slate-950 animate-gradient",
    notes: "Home hero, calculadora comiss\xE3o"
  },
  {
    id: "hero-dark-emerald",
    label: "Hero escuro (esmeralda)",
    tailwind: "bg-gradient-to-br from-slate-950 via-emerald-950 to-slate-950",
    notes: "Calculadora financiamento"
  },
  {
    id: "hero-dark-teal",
    label: "Hero escuro (teal)",
    tailwind: "bg-gradient-to-br from-slate-950 via-teal-950 to-slate-950",
    notes: "Calculadora CPL"
  },
  {
    id: "card-glow",
    label: "Brilho atr\xE1s de card",
    tailwind: "absolute -inset-4 bg-gradient-to-r from-indigo-500/20 via-purple-500/10 to-green-500/20 rounded-2xl blur-2xl",
    notes: "Home hero \u2014 camada atr\xE1s de mockup"
  },
  {
    id: "radial-hero-glow",
    label: "Radial topo (apresenta\xE7\xE3o)",
    css: "radial-gradient(ellipse 60% 50% at 50% -10%, rgba(99,102,241,0.22), transparent)",
    notes: "Sobreposi\xE7\xE3o em slides internos"
  },
  {
    id: "light-indigo-card",
    label: "Card claro \xEDndigo",
    tailwind: "bg-gradient-to-br from-indigo-50 to-white border border-indigo-200",
    notes: "Blocos de CTA em materiais"
  },
  {
    id: "light-emerald-card",
    label: "Card claro esmeralda",
    tailwind: "bg-gradient-to-br from-emerald-50 to-white border border-emerald-200",
    notes: "Rodap\xE9s de calculadoras"
  }
];
var ACCENT_GRADIENTS = [
  { id: "green-cta", tailwind: "from-green-500 to-emerald-600", usage: "Exit intent / materiais" },
  { id: "indigo-cta", tailwind: "from-indigo-500 to-violet-600", usage: "Materiais" },
  { id: "amber-cta", tailwind: "from-amber-500 to-orange-600", usage: "Destaque laranja" },
  { id: "purple-cta", tailwind: "from-purple-500 to-fuchsia-600", usage: "Varia\xE7\xE3o roxa" },
  { id: "cyan-cta", tailwind: "from-cyan-500 to-blue-600", usage: "Varia\xE7\xE3o azul" },
  { id: "bar-meta", tailwind: "from-violet-500 to-fuchsia-500", usage: "Barras CPL \u2014 Meta Ads" },
  { id: "bar-google", tailwind: "from-blue-500 to-cyan-500", usage: "Barras CPL \u2014 Google" },
  { id: "bar-portais", tailwind: "from-orange-500 to-amber-500", usage: "Barras CPL \u2014 portais" }
];
var CSS_UTILITIES = [
  { id: "shimmer", className: "shimmer", type: "animation", file: "public.css" },
  { id: "animate-gradient", className: "animate-gradient", type: "animation", file: "public.css" },
  { id: "animate-drift-slow", className: "animate-drift-slow", type: "animation", file: "public.css" },
  { id: "animate-drift-medium", className: "animate-drift-medium", type: "animation", file: "public.css" },
  { id: "animate-drift-fast", className: "animate-drift-fast", type: "animation", file: "public.css" },
  { id: "animate-glow", className: "animate-glow", type: "animation", file: "public.css" },
  { id: "animate-badge-pulse", className: "animate-badge-pulse", type: "animation", file: "public.css" },
  { id: "animate-hero-fade-in", className: "animate-hero-fade-in", type: "animation", file: "public.css" },
  { id: "bg-grid-dots", className: "bg-grid-dots", type: "pattern", file: "public.css" },
  { id: "bg-noise", className: "bg-noise", type: "texture", file: "public.css" },
  { id: "bg-noise-strong", className: "bg-noise-strong", type: "texture", file: "public.css" },
  { id: "perspective-800", className: "perspective-800", type: "layout", file: "public.css" },
  { id: "scrollbar-hide", className: "scrollbar-hide", type: "scrollbar", file: "public.css" },
  { id: "scrollbar-thin", className: "scrollbar-thin", type: "scrollbar", file: "public.css" }
];
var PUBLIC_ASSETS = [
  { path: "/imobdesk.svg", label: "Logo cor", usage: "Header, favicon alternativo" },
  { path: "/imobdesk-white.svg", label: "Logo branca", usage: "Fundos escuros" },
  { path: "/favicon.svg", label: "Favicon", usage: "Aba do navegador" },
  { path: "/stripe-logo.svg", label: "Stripe", usage: "Parceiro / integra\xE7\xE3o" }
];
var designTokensJson = {
  meta: DESIGN_TOKENS_META,
  fonts: FONTS,
  colors: COLORS,
  textGradients: TEXT_GRADIENTS,
  surfaceGradients: SURFACE_GRADIENTS,
  accentGradients: ACCENT_GRADIENTS,
  cssUtilities: CSS_UTILITIES,
  publicAssets: PUBLIC_ASSETS
};

export { ACCENT_GRADIENTS, COLORS, CSS_UTILITIES, DESIGN_TOKENS_META, FONTS, PUBLIC_ASSETS, SURFACE_GRADIENTS, TEXT_GRADIENTS, designTokensJson };
//# sourceMappingURL=index.mjs.map
//# sourceMappingURL=index.mjs.map